import React, { useEffect, useState } from 'react';
import useNotificationPoller from '../../hooks/useNotificationPoller';
import NotificationToast from './NotificationToast';
import { useLocation } from 'react-router-dom';
import StatusModal from './StatusModal';
import { fetchActiveOffers } from '../../api'; // Example of where we might get global info

const GlobalNotificationHandler = () => {
    const location = useLocation();
    const [userData, setUserData] = useState({ id: null, type: null });
    const [announcement, setAnnouncement] = useState(null);
    const [showAnnouncement, setShowAnnouncement] = useState(false);

    // Re-check auth whenever route changes (simple way to detect login/logout)
    useEffect(() => {
        const checkAuth = () => {
            const path = location.pathname;

            const adminData = localStorage.getItem("adminLoginData");
            const hostData = localStorage.getItem("hostLoginData");
            const userData = localStorage.getItem("userLoginData");

            const parseOrNull = (data) => {
                if (!data) return null;
                try {
                    const rawData = JSON.parse(data);
                    const parsed = rawData.data || rawData;
                    const token = parsed.token || rawData.token;
                    if (token) {
                        const id = parsed.userId || parsed.id || parsed.adminId || parsed.hostId || rawData.userId || rawData.adminId || rawData.hostId;
                        return { ...parsed, token, id };
                    }
                    return null;
                } catch (e) {
                    return null;
                }
            };

            const admin = parseOrNull(adminData);
            const host = parseOrNull(hostData);
            const user = parseOrNull(userData);

            let selected = null;
            let type = null;

            // Strict prioritization based on route
            if (path.startsWith("/admin") && admin) {
                selected = admin;
                type = 'ADMIN';
            } else if (path.startsWith("/host") && host) {
                selected = host;
                type = 'HOST';
            } else if (path.startsWith("/user") && user) {
                selected = user;
                type = 'USER';
            } else {
                // Fallback (prioritize by importance if not on specific route)
                if (admin) { selected = admin; type = 'ADMIN'; }
                else if (host) { selected = host; type = 'HOST'; }
                else if (user) { selected = user; type = 'USER'; }
            }

            if (selected) {
                setUserData({ id: selected.id, type });
            } else {
                setUserData({ id: null, type: null });
            }
        };

        checkAuth();
    }, [location.pathname]);

    const { latestNotification, clearNotification } = useNotificationPoller(userData.id, userData.type);

    // Sound effect & Announcement Check
    useEffect(() => {
        if (latestNotification) {
            console.log("GlobalNotificationHandler: Playing notification sound for", latestNotification.id);
            try {
                // Original notification sound
                const audio = new Audio("https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3");
                audio.volume = 1.0;
                audio.play().catch(e => console.warn("Audio play failed (Autoplay policy?):", e));
            } catch (error) {
                console.error("Failed to play notification sound", error);
            }

            // If it's an announcement, show modal instead of toast
            if (latestNotification.entityType === 'ANNOUNCEMENT' || latestNotification.title?.toLowerCase().includes('announcement')) {
                const seenAnnouncements = JSON.parse(localStorage.getItem('seen_announcements') || '[]');
                if (!seenAnnouncements.includes(latestNotification.id)) {
                    setAnnouncement(latestNotification);
                    setShowAnnouncement(true);

                    // Mark as seen immediately in local storage
                    seenAnnouncements.push(latestNotification.id);
                    localStorage.setItem('seen_announcements', JSON.stringify(seenAnnouncements));
                }
            }
        }
    }, [latestNotification]);

    const handleAnnouncementClose = () => {
        setShowAnnouncement(false);
        clearNotification();
    };

    return (
        <>
            <StatusModal
                show={showAnnouncement}
                onHide={handleAnnouncementClose}
                type="success"
                message={announcement?.message}
                title={announcement?.title}
                onConfirm={handleAnnouncementClose}
            />
            <div style={{ position: 'fixed', top: 0, right: 0, zIndex: 999999, pointerEvents: 'none' }}>
                <div style={{ pointerEvents: 'auto' }}>
                    <NotificationToast
                        notification={(!showAnnouncement && latestNotification?.entityType !== 'ANNOUNCEMENT') ? latestNotification : null}
                        onClose={clearNotification}
                        type={userData.type}
                    />
                </div>
            </div>
        </>
    );
};

export default GlobalNotificationHandler;
